var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/prop-types */
import React from 'react';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import { Icon } from '@ant-design/compatible';
import Tooltip from 'antd/lib/tooltip';
export default (function (props) {
    var title = props.title, help = props.help, children = props.children, rowProps = __rest(props, ["title", "help", "children"]);
    return (React.createElement(Row, __assign({ gutter: 8 }, rowProps),
        React.createElement(Col, { span: 3 }, title),
        React.createElement(Col, { span: 18 }, children),
        React.createElement(Col, { span: 3 },
            React.createElement(Tooltip, { placement: "topRight", arrowPointAtCenter: true, title: help },
                React.createElement(Icon, { type: "question-circle" })))));
});
